module.exports = __webpack_public_path__ + "core-fonts/maxpro_s-demibold-webfont.3e88aed424cdfa24ddae3f91b1cd63b6.eot";


//////////////////
// WEBPACK FOOTER
// ./src/main/ui/core/gfx/font/maxpro_s-demibold-webfont.eot
// module id = 14
// module chunks = 0